<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-交易设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">订单流程设置</div>
      <el-form-item label="未支付订单">
        <el-input v-model="form.closeDays" type="number" style="width: 200px;"></el-input>
        分钟后自动关闭
        <div class="tips">
          订单下单未付款，n天后自动关闭，设置0天不自动关闭
        </div>
      </el-form-item>

      <el-form-item label="已完成订单">
        <el-input v-model="form.refundDays" type="number" style="width: 200px;"></el-input>
        天内允许申请售后
        <div class="tips">
          订单完成后 ，用户在n天内可以发起售后申请，设置0天不允许申请售后
        </div>
      </el-form-item>
      <el-form-item label="冻结金额天数">
        <el-input v-model="form.receiveDays" type="number" style="width: 200px;"></el-input>
        天
        <div class="tips">
          注意：设置冻结金额天数7天，其他角色（技师、渠道、商户）的金额冻结时间也是7天
        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        closeDays: "",
        receiveDays: "",
        refundDays: "",
        freightRule: ""
      },
      loading: false
    };
  },
  created() {
    this.getParams();
  },

  methods: {
    getParams() {
      let self = this;
      SettingApi.tradeDetail({}, true)
        .then(data => {
          if (data.code == 1) {
              self.form=data.data
            // let vars = data.data.vars.values;
            // self.form.closeDays = vars.order.closeDays;
            // self.form.receiveDays = vars.order.receiveDays;
            // self.form.refundDays = vars.order.refundDays;
            // self.form.freightRule = vars.freightRule;
          }
        })
        .catch(error => {});
    },
    //监听复选框选中
    handleCheckedCitiesChange(val) {},
    onSubmit() {
      let self = this;
      self.loading = true;
      let form = self.form;
      SettingApi.editTrade(form, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，交易设置成功",
            type: "success"
          });
          self.$router.push("/setting/trade/index");
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: rgb(247, 147, 81);
}
</style>



// WEBPACK FOOTER //
// src/views/setting/trade/index.vue